import React, { useEffect, useState, KeyboardEvent } from "react";
import { Button, Modal, OverlayTrigger, Popover, Table } from "react-bootstrap";
import "../../../pages/css/BillingGroupPricing/BillingGroupPricing.css"
import { Checkbox } from "@fluentui/react";
interface newBillingTableDataProps {
    UtilityName: string
    BillingResponse: string
    BillingID: number
    LocatorResponse: string
    ResponseID: number
    Price?: number
    PS?: number
    UR?: string
    knt?: number
    Op?: string
    EffectiveDate: string
    ExpirationDate: string
    BillingGroupPriceID: number
    newPrice: string
    ContractExpirationDate: string
    IsAutoRenew: boolean
}
interface EventDictionary<TValue> {
    [id: string]: TValue
}
interface billingTableDataProps {
    UtilityName: string
    BillingResponse: string
    BillingID: number
    LocatorResponse: string
    ResponseID: number
    Price?: number
    PS?: number
    UR?: string
    knt?: number
    Op?: string
    EffectiveDate: string
    ExpirationDate: string
    BillingGroupPriceID: number
    ContractExpirationDate: string
    IsAutoRenew: boolean
}
interface utilityProps {
    UtilityID: number
    UtilityName: string
    ContractID: number
    ContractExpirationDate: string
}
interface newBillingGroupNewPricing {
    rowData?: newBillingTableDataProps[]
    cancelClick: () => void
    EffectiveDate: number
    confirmationCall: (date: string, id: number, utility: utilityProps) => void
    insertCall: (data: billingTableDataProps, utility: utilityProps) => void
    idSearch: (utility: string) => utilityProps
    billingGroupID: number
    percent:number
}

function BillingGroupNewPricing(props: newBillingGroupNewPricing) {
    const [data, setData] = useState(props.rowData)
    const [expireDate, setExpireDate] = useState<string>()
    const [createConfirmation, setCreateConfirmation] = useState(false)
    const [removeConfirmation, setRemoveConfirmation] = useState(false)
    const [removeConfirmationID, setRemoveConfirmationID] = useState<number>(-99)
    const [cancelConfirmation, setCancelConfirmation] = useState(false)
    const setIsAutoRenew = (i: number) => {
        if(data){
            const editData = data[i]
            editData.IsAutoRenew = !editData.IsAutoRenew
            if(editData.IsAutoRenew){
                editData.newPrice = (editData.Price ? (Math.round(editData.Price * (1 + props.percent / 100) * 100) / 100).toFixed(2) : "0.00")
            }
            else{
                editData.newPrice = editData.Price? editData.Price.toFixed(2): "0.00"
            }
            const copyData = data
            copyData[i] = editData
            setData([...copyData])
        }
    }
    const setRowData = (edit: string, i: number) => {
        let p: number
        if (data) {
            const editData = data[i]
            p = Number(edit) * 100
            //r-18-lint-cn
            //eslint-disable-next-line
            p = Math.floor(p) / 100
            editData.newPrice = edit
            const copyData = data
            const validated = edit.match(/^(-?\d*\.{0,1}\d{0,2}$)/)
            if (validated) {
                copyData[i] = editData
                setData([...copyData])
            }
        }
    }
    const [acDc, setACDC] = useState<EventDictionary<string>>({})

    const onConfirmationClick = () => {
        if (expireDate) {
            let utilityNames = new Set (data?.map(x => x.UtilityName)) ?? []
            utilityNames.forEach(x => {
                if(props.idSearch(x).UtilityID===-99){
                    alert("Cannot generate duplicate pricing records(unknown utility). Please refresh page and try again.")
                    return
                }
            })
            data?.forEach((x, index) => {
                let utility = props.idSearch(x.UtilityName)
                if(utility.UtilityID!==-99){
                    let res: billingTableDataProps = { ...x, Price: Number(x.newPrice), IsAutoRenew: x.IsAutoRenew }
                    props.insertCall(res, utility)
                    props.confirmationCall(expireDate, x.BillingGroupPriceID, utility)
                }
                else{
                    alert(`Unknown utility found in row ${index+1}, Biling group Pricing: ${x.BillingGroupPriceID}`)
                    return null
                }
            })
            props.cancelClick()
        }
        else {
            alert("Error Expiration Date not Found")
        }

    }

    const removeEntry = (id: number) => {
        let newData = data?.filter((x) => x.BillingGroupPriceID !== id)
        setData(newData)
    }

    const cancelGenerate = () => {
        props.cancelClick()
    }

    const sortData = (prop: string) => {
        let property = prop as keyof newBillingTableDataProps
        let copyData = data
        let sortOrder: EventDictionary<string> = {}
        if (acDc[prop] === 'arrow_drop_up') {
            copyData?.sort((a, b) => {
                //!!r-18-cn
                let c = a[property] ?? 0
                let d = b[property] ?? 0
                return c > d ? -1 : 1
            })
            sortOrder[prop] = 'arrow_drop_down'
        }
        else {
            copyData?.sort((a, b) => {
                let c = a[property] ?? 0
                let d = b[property] ?? 0
                return c > d ? 1 : -1
            })
            sortOrder[prop] = 'arrow_drop_up'
        }
        setACDC(sortOrder)
        setData(copyData)
    }

    useEffect(() => {
        let date = new Date(props.EffectiveDate)
        date.setUTCDate(date.getDate())
        date.setUTCHours(0, 0, 0, 0)
        setExpireDate(date.toISOString())
        setData(props.rowData)
        if(props.billingGroupID===-99){
            alert("Cannot generate duplicate pricing records(unknown billing group). Please refresh page and try again.")
            cancelGenerate()
        }
        //r-18-lint-cn
        //eslint-disable-next-line
    }, [])
    return (
        <div>
            <div className="BillingGroupTable">
                <Table>
                    <thead>
                        <tr className="tableHead">
                            <th onClick={() => sortData("UtilityName")}>Utility<span className="material-icons">{acDc["UtilityName"]}</span></th>
                            <th onClick={() => sortData("BillingResponse")}>Billing Response <span className="material-icons">{acDc["BillingResponse"]}</span></th>
                            <th onClick={() => sortData("BillingID")}>Billing ID <span className="material-icons">{acDc["BillingID"]}</span> </th>
                            <th onClick={() => sortData("LocatorResponse")}>Locator Response <span className="material-icons">{acDc["LocatorResponse"]}</span> </th>
                            <th onClick={() => sortData("ResponseID")}>Response ID <span className="material-icons">{acDc["ResponseID"]}</span></th>
                            <th onClick={() => sortData("IsAutoRenew")}>Auto Renew <span className="material-icons">{acDc["IsAutoRenew"]}</span></th>
                            <th onClick={() => sortData("Price")}>Price <span className="material-icons">{acDc["Price"]}</span></th>
                            <th onClick={() => sortData("NewPrice")}>New Price <span className="material-icons">{acDc["NewPrice"]}</span></th>
                            <th onClick={() => sortData("PS")}>P/S <span className="material-icons">{acDc["PS"]}</span></th>
                            <th onClick={() => sortData("UR")}>U/R  <span className="material-icons">{acDc["UR"]}</span></th>
                            <th onClick={() => sortData("knt")}>Knt <span className="material-icons">{acDc["knt"]}</span></th>
                            <th onClick={() => sortData("Op")}>Op <span className="material-icons">{acDc["Op"]}</span></th>
                            <th onClick={() => sortData("EffectiveDate")}>Effective Date <span className="material-icons">{acDc["EffectiveDate"]}</span></th>
                            <th onClick={() => sortData("ExpirationDate")}>Expiration Date <span className="material-icons">{acDc["ExpirationDate"]}</span></th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody className="NewEditTable">
                        {
                            data?.map((x, index) => (
                                <tr key={index}>
                                    <td>{x.UtilityName}</td>
                                    <td>{x.BillingResponse}</td>
                                    <td>{x.BillingID}</td>
                                    <td>{x.LocatorResponse}</td>
                                    <td>{x.ResponseID}</td>
                                    <td>
                                        <div style={{position: "relative", top:4}}>
                                            <Checkbox checked = {x.IsAutoRenew} onChange={() => setIsAutoRenew(index)}/>
                                        </div>
                                    </td>
                                    <td>${x.Price?.toFixed(2)}</td>
                                    <td className="editablesMid" style={{ width: `45px` }}>
                                        <div style={{ display: "flex", justifyContent: "left", alignItems: "center" }}>
                                            $<input
                                                id="billingPrice"
                                                type="number"
                                                value={x.newPrice}
                                                onChange={(e) => setRowData(e.target.value, index)}
                                                onFocus={(e) => e.target.select()}
                                                step="0.01"
                                                onKeyDown={(event: KeyboardEvent<HTMLDivElement>) => ['e', 'E', '+', '-'].includes(event.key) && event.preventDefault()}
                                            />
                                        </div>
                                    </td>
                                    <td>{x.PS}</td>
                                    <td>{x.UR}</td>
                                    <td>{x.knt}</td>
                                    <td>{x.Op}</td>
                                    <td>{x.EffectiveDate.split('T')[0]}</td>
                                    <td>2099-12-31</td>
                                    <td>
                                        {
                                            x.IsAutoRenew?
                                            null:
                                            <OverlayTrigger placement="left" overlay={
                                                <Popover id="bgp-panel-popover">
                                                    <Popover.Content>
                                                        <span>Row not marked for auto renewal. CPI not applied.</span>
                                                    </Popover.Content>
                                                </Popover>
                                            }>
                                                <span className="material-icons" style={{color: "orange"}} >
                                                    change_history
                                                </span>
                                            </OverlayTrigger>
                                        }
                                    </td>
                                    <td>
                                        <span className="material-icons" onClick={() => (setRemoveConfirmationID(x.BillingGroupPriceID), setRemoveConfirmation(true))}>
                                            delete
                                        </span>
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </Table>
            </div>
            <div className="newPricingRecordsButtons">
                <Button onClick={() => setCancelConfirmation(true)} variant='secondary' size="sm">Cancel</Button>
                <Button 
                    onClick={() => setCreateConfirmation(true)} 
                    variant={(data?.filter(x=> x.IsAutoRenew===true).length ?? 0)>0 ? 'primary': 'outline-dark'} 
                    size="sm" 
                    disabled={(data?.filter(x=> x.IsAutoRenew===true).length ?? 0)===0}
                >
                    Create new Pricing Records
                </Button>
            </div>
            <Modal show={createConfirmation} size="lg" onHide={() => setCreateConfirmation(false)}>
                <Modal.Header>
                    <span>
                        Are you sure you want to create  {
                            data?.length} new records and update {
                            data?.length} existing records
                    </span>
                </Modal.Header>
                <Modal.Footer>
                    <Button onClick={() => onConfirmationClick()} variant='primary'>Yes</Button>
                    <Button onClick={() => setCreateConfirmation(false)} variant='secondary'>No</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={removeConfirmation} size="lg" onHide={() => setRemoveConfirmation(false)}>
                <Modal.Header>
                    <span>Are you sure you want to remove this entry from the Duplicate table</span>
                </Modal.Header>
                <Modal.Footer>
                    {/*eslint-disable-next-line*/}
                    {/*eslint-disable-next-line*/}
                    <Button onClick={() => (removeEntry(removeConfirmationID), setRemoveConfirmation(false))} variant='primary'>Yes</Button>
                    <Button onClick={() => setRemoveConfirmation(false)} variant='secondary'>No</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={cancelConfirmation} size="lg" onHide={() => setCancelConfirmation(false)}>
                <Modal.Header>
                    <span>Are you sure you want to cancel Generating New Prices </span>
                </Modal.Header>
                <Modal.Footer>
                    {/*eslint-disable-next-line*/}
                    {/*eslint-disable-next-line*/}
                    <Button onClick={() => (cancelGenerate(), setCancelConfirmation(false))} variant='primary'>Yes</Button>
                    <Button onClick={() => setCancelConfirmation(false)} variant='secondary'>No</Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default BillingGroupNewPricing